import { useMemo } from "react";
import { useBrandGroups } from "./useBrandGroups";
import {
  findBrandGroupByBrandId,
  findBrandGroupByStoreKey,
} from "helpers/brand";
import { useFeatureRouteParams } from "helpers/shared/hooks/useFeatureRouteParams";
import type { IBrandGroup } from "helpers/transforms/entities";

export const useBrandGroup = (): IBrandGroup | null => {
  const { vendorLevel, vendorLocation } = useFeatureRouteParams();
  const { data: brandGroups } = useBrandGroups();
  return useMemo(() => {
    if (!brandGroups) {
      return null;
    }
    if (vendorLevel === "b") {
      return findBrandGroupByBrandId(vendorLocation, brandGroups) ?? null;
    } else if (vendorLevel === "s") {
      return findBrandGroupByStoreKey(vendorLocation, brandGroups) ?? null;
    } else {
      return brandGroups[0] ?? null;
    }
  }, [vendorLevel, vendorLocation, brandGroups]);
};
